import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ExpandableSection from "../../expandablesection";
import DoorLiteSearch from "./DoorLiteSearch"; // Import DoorLiteSearch component
import DoorLiteCollection from "./DoorLiteCollection";
import DoorLiteSize from "./DoorLiteSize";
import DoorLiteLites from "./DoorLiteLites";
import DoorLiteLocation from "./DoorLiteLocation";
import DoorLiteFrame from "./DoorLiteFrame";
import DoorLiteItems from "./DoorLiteItems";

const PanelDoorLite = forwardRef(({ onChange, doorSizeValueTriggered, 
                                              doorHeightValueTriggered, 
                                              passSelectedDoor,
                                              selectedPanel}, ref) => {
  const [doorLiteSearchValue, setDoorLiteSearchValue] = useState(""); // Updated state for DoorLiteSearch
  const [doorLiteCollectionValue, setDoorLiteCollectionValue] = useState("");
  const [doorLiteSizeValue, setDoorLiteSizeValue] = useState("");
  const [doorLiteItemsValue, setDoorLiteItemsValue] = useState([]);
  const [selectedDoorLiteValue, setSelectedDoorLiteValue] = useState();
  const [doorLiteLitesValue, setDoorLiteLitesValue] = useState("");
  const [doorLiteLocationValue, setDoorLiteLocationValue] = useState("");
  const [doorLiteFrameValue, setDoorLiteFrameValue] = useState("");


  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues1 = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        if (["doorLiteSize", "DoorLiteItems"].includes(control.id)) {
            // Use state value for Test component
            if (control.id === "doorLiteSize"){
              values[control.id] = doorLiteSizeValue ? doorLiteSizeValue : null;
            }
            if (control.id === "DoorLiteItems"){
              values[control.id] = selectedDoorLiteValue ? selectedDoorLiteValue.value : null;
          }
        } else {  
          const element = document.getElementById(control.id); // Query by control ID
          if (element) {
            values[control.id] = element.value; // Retrieve the current value
          } else {
            values[control.id] = null; // Handle missing elements
          }
        }
      });

    return values;
  };
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
        .filter((control) => control.status === "active") // Only active controls
        .forEach((control) => {
            if (["doorLiteSize", "DoorLiteItems"].includes(control.id)) {
                // Use state value for the respective control
                if (control.id === "doorLiteSize") {
                    values[control.id] = doorLiteSizeValue ? doorLiteSizeValue : null;
                }
                if (control.id === "DoorLiteItems") {
                    values[control.id] = selectedDoorLiteValue ? selectedDoorLiteValue.value : null;
                }
            } else {
                // Fall back to querying DOM elements
                const element = document.getElementById(control.id);
                if (element) {
                    values[control.id] = element.value; // Retrieve the current value
                } else {
                    values[control.id] = null; // Handle missing elements
                }
            }
        });

    return values;
};

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));

  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      doorLiteSearch: doorLiteSearchValue, // Updated the property name for DoorLiteSearch
      doorLiteCollection: doorLiteCollectionValue,
      doorLiteSize: doorLiteSizeValue,
      doorLiteLites: doorLiteLitesValue,
      doorLiteLocation: doorLiteLocationValue,
      doorLiteFrame: doorLiteFrameValue,
      doorLiteItems: doorLiteItemsValue,
      selectedDoorLite: selectedDoorLiteValue,
    });
  }, [doorLiteSearchValue, 
      doorLiteCollectionValue, doorLiteSizeValue, doorLiteLitesValue, 
      doorLiteLocationValue, doorLiteFrameValue,
      doorLiteItemsValue, selectedDoorLiteValue, onChange]);

  // Control map specific to DoorLite
  const controlMap = [
    {
      id: "DoorLiteSearch",
      component: (
        <DoorLiteSearch
          id="DoorLiteSearch"
          placeholder="Search..." // Placeholder for the search input
          onChange={(newValue) => {
            setDoorLiteSearchValue(newValue); // Update state for DoorLiteSearch
          }}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "DoorLite",
    },
    {
      id: "DoorLiteCollection",
      component: (
        <DoorLiteCollection
          id="DoorCollection"
          onChange={(newValue) => {
            setDoorLiteCollectionValue(newValue); 
          }}
        />
      ),
      position: [2, 1],
      status: "active",
      expandableSectionId: "DoorLite",
      },
      {
        id: "DoorLiteSize",
        component: (
          <DoorLiteSize
            id="DoorLiteSize"
            onChange={(selectedItem) => {
              console.log("Selected Item Received in Parent:", selectedItem);
              setDoorLiteSizeValue(selectedItem); // Update state with the selected item
            }}
            //onChange={(newValue) => {
            //  setDoorLiteSizeValue(newValue); 
            //}}
            //selectedCollection={doorLiteCollectionValue} // Pass Door lite Collection value, like Decorative Glass
            selectedPanel={selectedPanel}    //selected Door Panel, comes from Door Panel, like WG00 
            //selectedSize={doorLiteSizeValue}           
          />
        ),
        position: [2, 2],
        status: "active",
        expandableSectionId: "DoorLite",
      },
      {
        id: "DoorLiteLites",
        component: (
          <DoorLiteLites
            id="DoorLiteLites"
            onChange={(newValue) => {
              setDoorLiteLitesValue(newValue); 
            }}
            numberOfLites={doorLiteSizeValue.lites || 0} // Pass lites number
          />
        ),
        position: [2, 3],
        status: "active",
        expandableSectionId: "DoorLite",
      },
      {
        id: "DoorLiteLocation",
        component: (
          <DoorLiteLocation
            id="DoorLiteLocation"
            onChange={(newValue) => {
              setDoorLiteLocationValue(newValue); 
            }}
            isVisible={doorLiteSizeValue.location || 0} // Pass location
          />
        ),
        position: [3, 1],
        status: "active",
        expandableSectionId: "DoorLite",
      },  
      {
        id: "DoorLiteFrame",
        component: (
          <DoorLiteFrame
            id="DoorLiteFrame"
            onChange={(newValue) => {
              setDoorLiteFrameValue(newValue); 
            }}
            isVisible={doorLiteSizeValue.frame || 0} // Pass frame
          />
        ),
        position: [3, 2],
        status: "active",
        expandableSectionId: "DoorLite",
      },      
      {
        id: "DoorLiteItems",
        component: (
          <DoorLiteItems
            id="DoorLiteItems"
            value = {selectedDoorLiteValue}
            onChange={(newValue) => {
              setSelectedDoorLiteValue(newValue); 
            }}
            selectedCollection={doorLiteCollectionValue} // Pass DoorCollection value
            selectedSize={doorLiteSizeValue.value || 0}  
            doorSizeValueToFunc={doorSizeValueTriggered} // Pass the actual prop
            doorHeightValueToFunc={doorHeightValueTriggered} // Pass the actual prop
            passSelectedDoor={passSelectedDoor} //pass selected door
            searchByName={doorLiteSearchValue}
          />
        ),
        position: [4, 1],
        status: "active",
        expandableSectionId: "DoorLite",
      },
  ];

  return (
    <ExpandableSection 
      title={`Door Lite${selectedDoorLiteValue ? ` (${selectedDoorLiteValue.value})` : ""}`} // Dynamically add selected panel name
      id="doorLitePanel"
      state="false"
      panelLocation="116"
      controlMap={controlMap.filter((control) => control.expandableSectionId === "DoorLite")}
    />
  );
});

export default PanelDoorLite;
